module.exports = __webpack_public_path__ + "img/bill.e2094ebd.svg";